import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Divider
} from 'semantic-ui-react'

const CardSelfServiceScheduleUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardSelfServiceScheduleUX-div-0"
        style={{width: "100%",height:"100%",padding:"10px"}}>
        {}
        <Form
          id="CardSelfServiceScheduleUX-Form-1">
          <FormGroup
            id="CardSelfServiceScheduleUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardSelfServiceScheduleUX-FormField-5"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("WorkSchedule")?"":"none"}}>
              <Button
                color={props.activeTab === "WorkSchedule" ? "blue" : undefined}
                id="CardSelfServiceScheduleUX-Button-8"
                onClick={() => props.onHandleChangeTab("WorkSchedule")}
                size="small">
                My shift schedule
              </Button>
            </FormField>
            <FormField
              id="CardSelfServiceScheduleUX-FormField-6"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("TimeAttendance")?"":"none"}}>
              <Button
                color={props.activeTab === "TimeAttendance" ? "blue" : undefined}
                id="CardSelfServiceScheduleUX-Button-9"
                onClick={() => props.onHandleChangeTab("TimeAttendance")}
                size="small">
                Time Attendance
              </Button>
            </FormField>
            <FormField
              id="CardSelfServiceScheduleUX-FormField-7"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("LeaveHistory")?"":"none"}}>
              <Button
                color={props.activeTab === "LeaveHistory" ? "blue" : undefined}
                id="CardSelfServiceScheduleUX-Button-10"
                onClick={() => props.onHandleChangeTab("LeaveHistory")}
                size="small">
                Leave History
              </Button>
            </FormField>
            <FormField
              id="CardSelfServiceScheduleUX-FormField-12"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("TrainingHistory")?"":"none"}}>
              <Button
                color={props.activeTab === "TrainingHistory" ? "blue" : undefined}
                id="CardSelfServiceScheduleUX-Button-13"
                onClick={() => props.onHandleChangeTab("TrainingHistory")}
                size="small">
                Training History
              </Button>
            </FormField>
            <FormField
              id="CardSelfServiceScheduleUX-FormField-14"
              style={{display: props.filteredTabMenu?.includes("PaySlip")?"":"none"}}>
              <Button
                color={props.activeTab === "PaySlip" ? "blue" : undefined}
                id="CardSelfServiceScheduleUX-Button-15"
                onClick={() => props.onHandleChangeTab("PaySlip")}
                size="small">
                Pay Slip
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Divider
          id="CardSelfServiceScheduleUX-Divider-11">
        </Divider>
        <div
          id="CardSelfServiceScheduleUX-div-3">
          {props.displayTab}
        </div>
      </div>
    )
}


export default CardSelfServiceScheduleUX

export const screenPropsDefault = {}

/* Date Time : Wed Jul 16 2025 11:54:44 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.displayTab"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-div-3"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"WorkSchedule\")?\"\":\"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"TimeAttendance\")?\"\":\"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"LeaveHistory\")?\"\":\"none\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "My shift schedule"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"WorkSchedule\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Button-8"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"WorkSchedule\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Time Attendance"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"TimeAttendance\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Button-9"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"TimeAttendance\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Leave History"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"LeaveHistory\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"LeaveHistory\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Divider",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Divider-11"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"TrainingHistory\")?\"\":\"none\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Training History"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"TrainingHistory\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"TrainingHistory\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"PaySlip\")?\"\":\"none\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Pay Slip"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"PaySlip\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardSelfServiceScheduleUX-Button-15"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"PaySlip\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 15,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardSelfServiceScheduleUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
